import { Login } from "../pages/login";
import { MasterHome, PreceptorHome, StudentHome, TeacherHome } from "../pages";

const Routes = [
  {
    path: "/masterhome",
    component: MasterHome,
    // exact: true,
  },
  {
    path: "/preceptorhome",
    component: PreceptorHome,
  },
  {
    path: "/studenthome",
    component: StudentHome,
  },
  {
    path: "/teacherhome",
    component: TeacherHome,
  },
  {
    path: "/",
    component: Login,
    exact: true,
  },
  // {
  //   path: '/*',
  //   component: NotFound,
  // },
];

export default Routes;
